import React, { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { List, ListItemAvatar, ListItem, ListItemText, Grid, Box, Typography, Button, Stack } from '@mui/material';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';


import { FontAwesomeSvgIcon } from '../components/FontAwesomeSvgIcon';
import { CustomSettingButton } from '../components/Button/CustomButton';
import { LegendItems } from '../components/LegendItems';

// const listLegendItin = ['acc', 'part_acc', 'not_acc', 'not_spec', 'bus'];

export const LegendContentControl = ({ isMobile, allResults }) => {
  const layerConf = useSelector(state => state.layerConf);
  const layerList = layerConf.buttonsLayersState;
  const {list, show} = useSelector(state => state.legendList);
  const [layerVisibleList, setLayerVisibleList] = useState([]);
  const [showLegend, setShowLegend] = useState(false);
  const {t} = useTranslation();

  const styles = {
    buttonSetting: {
      padding: 1,
      maxWidth: '150px',
      borderRadius: '0.5em',
      fontSize: isMobile ? '1.7em' : '0.875em',
      border: '1px solid',
      fontStyle: 'normal',
      textTransform: 'none',
    }
  };

  useEffect(() => {
    setLayerVisibleList([]);
    let newList = [];
    for (const key in layerList) {
      if (layerList[key].active === true) {
        newList.push(layerList[key]);
      }
    }
    setLayerVisibleList(newList);
  }, [layerConf]);

  return (
    <>
      {isMobile || showLegend && isMobile === false ? (
        <Box
          sx={{
            width: 300,
            height: 400,
            backgroundColor: 'white',
            opacity: [0.9],
          }}
        >
          <Stack sx={{ display: 'flex', width: '100%' }} direction='column' spacing={1}>
            {isMobile === false &&
              <Box sx={{ display: 'flex', width: '100%' }}>
                <Box sx={{ display: 'flex', width: '90%' }}>
                  <Typography sx={{ mt: 1, ml: 2}} color='primary' variant="h6" component="div">
                    {t('legend.title')}
                  </Typography>
                </Box>
                <Box sx={{ mt: 1, display: 'flex' }}>
                  <Button aria-label={t('legend.close')} variant='text' onClick={() => setShowLegend(false)}>
                    <FontAwesomeSvgIcon icon={faTimes} />
                  </Button>
                </Box>
              </Box>
            }
            <Box sx={{ display: 'flex', width: '100%' }}>
              <Grid item>
                <List 
                  sx={{
                    '&::-webkit-scrollbar': {
                      width: '4px'
                    },
                    '&::-webkit-scrollbar-track': {
                      width: '2px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      borderRadius: '0.5em',
                      backgroundColor: 'gray'
                    },
                    
                  }}
                  style={{ maxHeight: isMobile ? null : 330, minWidth: 300, overflow: 'auto' }}
                  dense={true}
                >
                  {show ? (
                    <>
                      {list.map((legend, index) => {
                        return (
                          <LegendItems  key={index} nameAcc={legend} />
                        );
                      })}
                    </>
                  ) : (
                    <>
                      {status === 'success' && allResults.length > 0 && 
                   (
                     <>
                       {list.map((legend, index) => {
                         return (
                           <LegendItems  key={index} nameAcc={legend} />
                         );
                       })}
                     </>
                   )
                      }
                    </>
                  )}
                  {layerVisibleList.map((layerInfos) => {
                    return layerInfos.legendIcons.map((pngIcon, index) => {
                      return (
                        <ListItem key={pngIcon}>
                          <ListItemAvatar>
                            <img src={pngIcon} width="30px" height="30px"/>
                          </ListItemAvatar>
                          <ListItemText
                            primary={layerInfos.legendLabels[index]}
                            disableTypography={true}
                          />
                        </ListItem>
                      );
                    });
                  }
                  )}
                </List>
              </Grid>
            </Box>
          </Stack>
        </Box>) : (
        <CustomSettingButton 
          onClick={() => setShowLegend(true)} 
          sx={styles.buttonSetting}
          size='small'
        >
          {t('legend.open')} 
        </CustomSettingButton>
      )
      }
    </>
  );
};